"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var track_event_1 = __importDefault(require("../../../utils/track-event"));
var Tag_1 = __importDefault(require("./Tag"));
var TagList = function (props) {
    var tags = props.tags, _a = props.withChildren, withChildren = _a === void 0 ? false : _a, tagClick = props.tagClick, _b = props.visible, visible = _b === void 0 ? true : _b;
    if (!visible)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null, tags.map(function (tag) { return (react_1.default.createElement(Tag_1.default, { tag: tag, handleClick: tagClick, key: tag.name, withChildren: withChildren },
        react_1.default.createElement(TagList, { visible: Boolean(withChildren && tag.children.length), tags: tag.children, tagClick: function (tagName) { return function (e) {
                tagClick(tagName)(e);
                (0, track_event_1.default)({
                    category: 'store button',
                    action: 'tag link click',
                    label: tagName,
                });
            }; }, withChildren: false }))); })));
};
exports.default = TagList;
